import { flagActions } from '../../services';

export const flagDispatcher = dispatch => ({
  showSearchText : () => dispatch( { type: flagActions.SHOWSEARCH}),
  hideSearchText : () => dispatch( { type: flagActions.HIDESEARCH}),
  enableRemoveMethodForConfigurator:(variableName) => dispatch({type:flagActions.ENABLEREMOVEMETHODCALL, variableName:variableName}),
  disableRemoveMethodForConfigurator: () => dispatch({type:flagActions.DISABLEREMOVEMETHODCALL}),
  adding: () => dispatch({type: 'dispatch-busy', action: flagActions.ADDING }),
  notAdding: () => dispatch({type: 'dispatch-complete', action: flagActions.ADDING}),
  showSearchOverlay:() => dispatch({type: flagActions.SHOWSEARCHOVERLAY}),
  hideSearchOverlay:() => dispatch({type:flagActions.HIDESEARCHOVERLAY}),
  showMobileSearchHeader: ()=>dispatch({type:flagActions.SHOWMOBILESEARCHHEADER}),
  hideMobileSearchHeader: ()=>dispatch({type:flagActions.HIDEMOBILESEARCHHEADER}),
  importing: ()=>dispatch({type:flagActions.IMPORTING}),
  notImporting: ()=>dispatch({type:flagActions.NOTIMPORTING}),
  busy:()=>dispatch({type:flagActions.BUSY}),
  notBusy:()=>dispatch({type:flagActions.NOTBUSY}),
});